import React, { useState, useEffect, useRef } from "react";
import PrizeForm from "./PrizeForm";
import Pagination from "../../../utils/pagination/Pagination";
import { Trash2, SquarePen, Eye, Plus } from "lucide-react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import ProgressBar from "../../../utils/progressBar/ProgressBar";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Checkbox,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Button,
  Spinner,
  ModalCloseButton,
} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import {
  getCountPriceList,
  getPricelist,
} from "../../../redux/reduxApi/PriceRedux";
import { deletePriceList } from "../../../redux/api/priceapi/PriceApi";
import EllipsisMenu from "../../../utils/EllipsisDropdown/EllipsisMenu";
// import "./Prize.css";
import { useNavigate } from "react-router-dom";
import { formatDate } from "../../../utils/commonFunction/CommonFunction";

function PrizeList(sidebarColor) {
  const desktopRef = useRef(null);
  const navigate = useNavigate();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setToatalPage] = useState(1);
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [totalCount] = useState(50);
  const [deletePrizesROWID, setDeletePrizesROWID] = useState("");
  const [showProgressBar, setShowProgressBar] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [dataToEdit, setDataToEdit] = useState({});
  const [prizesROWId, setPrizesROWId] = useState("");
  const [prizesId, setPrizesId] = useState("");
  const dispatch = useDispatch();
  const prizesData = useSelector((state) => state.PriceData.PriceList);
  console.log("priceDatas", prizesData);
  const prizesCount = useSelector((state) => state.PriceData.PriceListCount);

  // const [prizesData, setPrizesData] = useState([
  //   {
  //     prizes: {
  //       ROWID: 1,
  //       panels: 15,
  //       projectKW: 5.5,
  //       warranty: "25 Years",
  //       inverterCapacity: "5kW",
  //       inverterWarranty: "10 Years",
  //       totalCost: "$8,500",
  //       subsidy: "$2,000",
  //       afterSubsidy: "$6,500",
  //     },
  //   },
  //   {
  //     prizes: {
  //       ROWID: 2,
  //       panels: 20,
  //       projectKW: 7.5,
  //       warranty: "30 Years",
  //       inverterCapacity: "7.5kW",
  //       inverterWarranty: "12 Years",
  //       totalCost: "$12,000",
  //       subsidy: "$3,500",
  //       afterSubsidy: "$8,500",
  //     },
  //   },
  // ]);

  useEffect(() => {
    const data = async () => {
      try {
        setLoading(true);
        const response = await dispatch(
          getPricelist({ page: currentPage, limit: 250 })
        );
        const countResponse = await dispatch(getCountPriceList());
        console.log("response", response);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        setShowProgressBar(false);
        console.error("Error fetching data:", error);
      }
    };
    data();
  }, [dispatch, currentPage]);

  useEffect(() => {
    if (prizesCount) {
      const totalPages = Math.ceil(prizesCount / 30); // Assuming 30 items per page
      setToatalPage(totalPages);
    }
  }, [prizesCount, currentPage]);

  // Dummy permissions - replace with actual permissions
  const permissions = localStorage.getItem("permissions");
  const filterData = permissions
    ? JSON.parse(permissions)
    : [{ moduleName: "Prize", add: true, delete: true, modifyAll: true }];

  const handleDelete = async () => {
    setShowProgressBar(true);
    setLoading(true);

    try {
      const rep = await deletePriceList(deletePrizesROWID);
      console.log("delete response", rep);
      if (rep.data.success) {
        toast.success("Deleted successfully", { autoClose: 2000 });
        setShowProgressBar(false);
        setLoading(false);
        setIsOpen(false);
        // setSelectedRows([]);
        dispatch(getPricelist({ page: currentPage, limit: 30 }));
      }
    } catch (error) {}
  };

  const openTrash = (ROWID) => {
    setDeletePrizesROWID(ROWID);
    setIsOpen(true);
  };

  const closeTrash = () => setIsOpen(false);

  const handleRowSelect = (ROWID) => {
    setSelectedRows((prev) =>
      prev.includes(ROWID)
        ? prev.filter((id) => id !== ROWID)
        : [...prev, ROWID]
    );
    setPrizesROWId(selectedRows.join(","));
  };

  const handleSelectAllRows = () => {
    setSelectedRows((prev) =>
      prev.length === prizesData.length
        ? []
        : prizesData.map((item) => item.priceListResponse.ROWID)
    );
  };

  const openDrawer = () => setIsDrawerOpen(true);
  const closeDrawer = () => {
    setIsUpdateMode(false);
    setDataToEdit({});
    setIsDrawerOpen(false);
  };

  return (
    <>
      {loading && (
        <div className="spinner-overlay">
          <Spinner size="xl" color="pink.500" />
        </div>
      )}
      {showProgressBar && <ProgressBar colorScheme="pink" />}

      <Modal isOpen={isOpen} onClose={closeTrash}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Delete Confirmation</ModalHeader>
          <ModalCloseButton />
          <ModalBody>Are you sure you want to delete this entry?</ModalBody>
          <ModalFooter>
            <Button className="create-button" mr={3} onClick={handleDelete}>
              Delete
            </Button>
            <Button className="cancel-button" onClick={closeTrash}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <div>
        <div ref={desktopRef}>
          <div className="d-flex justify-content-end w-100">
            {selectedRows.length > 0 && (
              <div className="align-items-left mt-2 d-flex gap-2 w-50">
                <button className="new-button" onClick={openTrash}>
                  Delete All
                </button>
              </div>
            )}
            <div className="d-flex justify-content-end w-50">
              <button
                className="new-button mx-2"
                style={{ backgroundColor: sidebarColor }}
                onClick={openDrawer}
              >
                <Plus size="18px" />
                <span className="ms-1">New</span>
              </button>
            </div>
          </div>
        </div>

        <div className="custom-scroll" style={{ minHeight: "75vh" }}>
          <TableContainer
            className="card card-detail mt-1"
            style={{
              maxHeight: "72vh",
              width: "100%",
              position: "relative",
              overflowY: "scroll",
              overflowX: "scroll",
              scrollbarColor: "#A0AEC0 #EDF2F7",
              scrollbarWidth: "10px",
            }}
          >
            {" "}
            <Table variant="simple" size="sm">
              <Thead>
                <Tr className="tr-border">
                  <Th className="py-1 th-color" style={{ width: "50px" }}>
                    <Checkbox
                      isChecked={selectedRows.length === prizesData.length}
                      onChange={handleSelectAllRows}
                    />
                  </Th>
                  <Th className="py-1 th-color">Actions</Th>
                  <Th className="py-1 th-color">Brand</Th>
                  <Th className="py-1 th-color">Solar Type</Th>
                  <Th className="py-1 th-color">CREATEDTIME</Th>
                  <Th className="py-1 th-color">MODIFIEDTIME</Th>
                  <Th className="py-1 th-color">CREATEDBY</Th>
                </Tr>
              </Thead>
              <Tbody>
                {prizesData.map((item, index) => {
                  const solarTypes = Object.keys(
                    item.solarPricingSpecificationsGrouped
                  ).join(", ");
                  return (
                    <Tr
                      key={index}
                      className="tr-border"
                      style={{ position: "relative" }}
                    >
                      <Td>
                        <Checkbox
                          isChecked={selectedRows.includes(
                            item.priceListResponse.ROWID
                          )}
                          onChange={() =>
                            handleRowSelect(item.priceListResponse.ROWID)
                          }
                        />
                      </Td>
                      <Td
                        style={{ width: "110px", textAlign: "center" }}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <EllipsisMenu
                          item={item}
                          onView={() =>
                            navigate("/price-detail", { state: { item: item } })
                          }
                          onEdit={() => {
                            openDrawer(item);
                            setDataToEdit(item);
                            setIsUpdateMode(true);
                          }}
                          onDelete={() => {
                            openTrash(item?.priceListResponse?.ROWID);
                          }}
                          permissions={{
                            canEdit: filterData?.find(
                              (mod) =>
                                mod.moduleName === "Price List" &&
                                mod.modifyAll === true
                            ),
                            canDelete: filterData?.find(
                              (mod) =>
                                mod.moduleName === "Price List" &&
                                mod.delete === true
                            ),
                            canView: true,
                            canEdit: true,
                            canDelete: true,
                          }}
                        />
                      </Td>
                      <Td className="font-colors">
                        {item.brand.solarBrandName}
                      </Td>
                      <Td className="font-colors">{solarTypes}</Td>
                      <Td className="font-colors">
                        {formatDate(item.priceListResponse.CREATEDTIME)}
                      </Td>
                      <Td className="font-colors">
                        {formatDate(item.priceListResponse.MODIFIEDTIME)}
                      </Td>
                    </Tr>
                  );
                })}
              </Tbody>
            </Table>
          </TableContainer>
        </div>

        <div className="footer">
          <div className="footer d-flex fixed-bottom start-20">
            <div
              className="total"
              style={{ marginLeft: "16%", marginTop: "15px" }}
            >
              <p className="fw-semibold">Total Count: {prizesData.length}</p>
            </div>
            <div className="d-flex align-items-center justify-content-center position-fixed-bottom mx-auto">
              <Pagination
                totalPages={totalPages}
                onPageChange={setCurrentPage}
              />
            </div>
            <PrizeForm
              isDrawerOpen={isDrawerOpen}
              closeDrawer={closeDrawer}
              isUpdateMode={isUpdateMode}
              prizesId={prizesId}
              dataToEdit={dataToEdit}
              setIsUpdateMode={setIsUpdateMode}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default PrizeList;
